























































































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class ImageUploaderButton extends Vue {
  dialog: boolean = false
  files: File[] = []

  get srcs (): string[] {
    return this.files.map(f => window.URL.createObjectURL(f))
  }
  get okButtonDisabled (): boolean {
    return this.files.length === 0
  }
  get okButtonText (): string {
    if (this.files.length === 0) {
      return 'Add images'
    } else if (this.files.length === 1) {
      return 'Add 1 image'
    } else {
      return `Add ${this.files.length} images`
    }
  }

  okButtonClicked () {
    this.$emit('update:files', this.files)
    this.files = []
    this.dialog = false
  }
}

